function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.6499 14.4751C13.5624 14.4626 13.4499 14.4626 13.3499 14.4751C11.1499 14.4001 9.3999 12.6001 9.3999 10.3876C9.3999 8.1251 11.2249 6.2876 13.4999 6.2876C15.7624 6.2876 17.5999 8.1251 17.5999 10.3876C17.5874 12.6001 15.8499 14.4001 13.6499 14.4751Z",
    stroke: "#D1D1D1",
    style: {
      stroke: "#D1D1D1",
      stroke: "color(display-p3 0.8201 0.8201 0.8201)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9249 22.7252C19.6999 24.7627 16.7499 26.0002 13.5 26.0002C10.25 26.0002 7.29995 24.7627 5.07495 22.7252C5.19995 21.5502 5.94995 20.4002 7.28745 19.5002C10.7125 17.2252 16.3124 17.2252 19.7124 19.5002C21.0499 20.4002 21.7999 21.5502 21.9249 22.7252Z",
    stroke: "#D1D1D1",
    style: {
      stroke: "#D1D1D1",
      stroke: "color(display-p3 0.8201 0.8201 0.8201)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 26C20.4036 26 26 20.4036 26 13.5C26 6.59644 20.4036 1 13.5 1C6.59644 1 1 6.59644 1 13.5C1 20.4036 6.59644 26 13.5 26Z",
    stroke: "#D1D1D1",
    style: {
      stroke: "#D1D1D1",
      stroke: "color(display-p3 0.8201 0.8201 0.8201)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.c9ab42547e3d30a3eb1fc8ed5428f77f.svg";
export { ForwardRef as ReactComponent };